import { EnergyRating as JLDSEnergyRating } from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import classNames from "classnames";
import styles from "./EnergyRating.module.scss";
import {
  CardComponentProps,
  RatingLegacyValue,
  RatingValue,
} from "@~/types/types";
import { useState } from "react";
import { EnergyDrawer } from "./components/EnergyDrawer";
import { dispatchAdTechAnalyticsEvent } from "@~/utils/analytics";

export function EnergyRating({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { variant } = useVariant();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [altText, setAltText] = useState<string | undefined>(undefined);

  if (!variant?.energy) {
    return null;
  }

  const { rating } = variant.energy;
  const { associatedAdvertId, clickUrl, impressionUrl } =
    product.advertising || {};

  return (
    <div data-component="pcl-EnergyRating">
      <JLDSEnergyRating
        className={classNames(styles.energyRating, {
          [styles.legacy!]: rating.legacy,
          [styles.energyRating__large!]: configProps?.size === "large",
        })}
        rating={rating.legacy ? undefined : (rating.value as RatingValue)}
        ratingLegacy={
          rating.legacy ? (rating.value as RatingLegacyValue) : undefined
        }
        hasEnergySideDrawer
        handleEnergyRatingClick={(alt) => {
          setAltText(alt);
          setDrawerOpen(true);
          if (associatedAdvertId) {
            dispatchAdTechAnalyticsEvent({
              productId: product.aliases.pimProductId,
              associatedAdvertId,
              clickUrl,
              impressionUrl,
            });
          }
        }}
      />
      <EnergyDrawer
        handleClose={() => setDrawerOpen(false)}
        isOpen={drawerOpen}
        energy={variant.energy}
        altText={altText}
      />
    </div>
  );
}
